import AtomicSSL from "../../../../src/courses/partials/atomic/ssl.mdx";
import * as React from 'react';
export default {
  AtomicSSL,
  React
};